export const getLastUpdated = () => {
  const iso = process.env.REACT_APP_BUILD_TIME;

  if (!iso) return 'Unknown';

  const date = new Date(iso);
  return new Intl.DateTimeFormat('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/London',
    hour12: false,
  }).format(date);
};
